import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Deep Flatten Object",
  url: "deep-flatten-object",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {object {}} obj
* @return {object}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
* You can change the parameters though
*/

return function deepFlatten(obj) {
  // your code goes here        
};
`,
};

export default info;
